module.exports = __webpack_public_path__ + "static/q16_x-b0b0baf330faff6c22ea98e367ae11b0.png";